module.exports = __webpack_public_path__ + "img/title+@3x.e188f782.png";